export default __webpack_public_path__ + "static/Denver-eb1cc8e3f373b46789cbd82394e1b1b3.webp";